import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=abda4606&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abda4606",
  null
  
)

export default component.exports